// Conflict overlay — ACLED + GDELT armed events as MIL-STD-2525 hostile
// frames (square) tinted by severity. Same renderer as sanctions, scoped
// to CFL signals.

import type { intel as i } from '@eidollon/contracts';
import { buildIconLayer } from './_icon-builder.js';
import { withGeom } from './_shared.js';
import type { LayerSpec } from './registry.js';

const TYPES: readonly i.SignalType[] = ['CFL'];
const TYPE_SET = new Set<i.SignalType>(TYPES);

export const conflictsLayer: LayerSpec = {
  id: 'conflicts',
  label: 'CFL · conflict',
  kind: 'icon',
  signalTypes: TYPES,
  color: 'var(--amber)',
  colorAxis: 'category',
  description: 'Active conflict events from ACLED + GDELT',
  classification: 'OPEN',
  legend: {
    swatch: 'var(--amber)',
    label: 'CFL',
    hint: 'ACLED + GDELT armed events',
  },
  select: (rows) => withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type)),
  // Always visible — the feed is capped at ~200 rows so there is no clutter,
  // and a single-type filter must show that type at ANY zoom (otherwise the
  // map goes empty below the old threshold). See route bug: "toggle on -> disappear".
  visibleAtZoom: () => true,
  deckLayer: ({ rows, viewport, onPick }) => {
    const data = withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type));
    return buildIconLayer({
      id: 'intel-conflicts',
      rows: data,
      zoom: viewport.zoom,
      sizeMin: 10,
      sizeMax: 24,
      onPick,
    });
  },
};
